import { Select2 } from '@economic/taco';
import React from 'react';
import useQuery from '~/app/shared/hooks/useQuery';
import { PaymentAccountDto } from '~/types/internal-api';

// Use with <Field/> as Select2 is not compatible with <Field.Dropdown/>
// Example:
// <Field name="paymentAccount" label={t`Bank account`} as={BankAccountDropdown} />

export const BankAccountDropdown = props => {
    const { data }: any = useQuery<PaymentAccountDto[]>('/paymentAccounts/accounts', []);

    return (
        <Select2 className="w-20" {...props} value={props.value}>
            {data.map(({ number, bankName, bankAccountNumber }: PaymentAccountDto) => (
                <Select2.Option key={bankAccountNumber} value={bankAccountNumber}>
                    {`${number} ${bankName} - ${bankAccountNumber}`}
                </Select2.Option>
            ))}
        </Select2>
    );
};
